import { render, staticRenderFns } from "./BottomChat.vue?vue&type=template&id=85fc8fc2"
import script from "./BottomChat.vue?vue&type=script&lang=js"
export * from "./BottomChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85fc8fc2')) {
      api.createRecord('85fc8fc2', component.options)
    } else {
      api.reload('85fc8fc2', component.options)
    }
    module.hot.accept("./BottomChat.vue?vue&type=template&id=85fc8fc2", function () {
      api.rerender('85fc8fc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/inc/BottomChat.vue"
export default component.exports